module.exports = __webpack_public_path__ + "img/bg.72e140f1.png";